module.exports = __webpack_public_path__ + "img/br.562cc66.webp";